import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { ContactDetails, ContactDetailsForm } from './contact-details.model';

/** The ApContactDetailsService is used to create a formGroup. To be used with {@link ApContactDetailsComponent} */
@Injectable()
export class ApContactDetailsService {
    /**
     * Function to create a Contact Details form group
     * @param contactDetails
     * @param isPhoneReadonly
     * @param showPhoneNumber
     * @param showEmailAddress
     * @returns FormGroup<ContactDetailsForm>
     */
    public createFormGroup(
        contactDetails: ContactDetails = {} as ContactDetails,
        isPhoneReadonly = false,
        showPhoneNumber = true,
        showEmailAddress = true
    ): FormGroup<ContactDetailsForm> {
        const formGroup = new FormGroup<ContactDetailsForm>({});
        if (showEmailAddress) {
            formGroup.addControl(
                'emailAddress',
                new FormControl<string>(contactDetails.emailAddress, {
                    validators: [Validators.required],
                    nonNullable: true
                })
            );
        }
        if (showPhoneNumber) {
            formGroup.addControl(
                'phoneNumber',
                new FormControl<string>({
                    value: contactDetails.phoneNumber,
                    disabled: isPhoneReadonly
                })
            );
            if (!isPhoneReadonly) {
                formGroup.controls.phoneNumber.setValidators([Validators.required]);
            }
        }
        return formGroup;
    }
}
